var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.935 0.949837C76.999 1.51984 77.869 2.75684 77.869 3.69984C77.869 6.47484 57.794 74.2008 56.241 76.6648C55.461 77.9028 54.325 78.9148 53.717 78.9148C53.109 78.9148 48.703 75.0898 43.925 70.4148L35.239 61.9148H26.589C16.152 61.9148 15.869 61.6058 15.869 50.2068V42.3678L7.86901 34.4148C-0.0109897 26.5808 -1.34599 24.1528 1.11901 22.1378C2.00301 21.4148 55.092 5.22184 73.685 0.00383789C73.858 -0.0451621 74.871 0.380837 75.935 0.949837Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.796 17.9912C33.796 21.2532 21.692 24.8602 17.898 26.0062L11 28.0892L23.6 40.8032L51.796 26.7692L23.823 54.9422H37.742L43.992 61.1362C47.429 64.5432 50.443 67.1282 50.69 66.8812C51.056 66.5162 57.298 45.7812 65.8 16.6922C66.844 13.1202 66.892 11.9572 65.992 12.0012C65.334 12.0332 55.796 14.7292 44.796 17.9912Z",
    fill: "#FCFCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.4cad9a4c4ba8c267df5034f1843deff5.svg";
export { ForwardRef as ReactComponent };